module.exports = function(media) {
	'use strict'
	media.directive('setFeaturedVideo',setFeaturedVideo);
	setFeaturedVideo.$inject=['$filter','config','$rootScope','getDataService','serverError','refreshtokenService','$timeout','reqursiveService', 'offlineError','alertService'];
	function setFeaturedVideo($filter,config,$rootScope,getDataService,serverError,refreshtokenService,$timeout,reqursiveService, offlineError, alertService) {
		return {
			restrict: 'E',
			scope: {
				currentPostObj:"=",
				scheduled:'='
			},
			template: require('./video/js/directive/partial/setFeaturedVideo.html'),
			link: function(scope, ele, $attrs, ctrl) {
				var s;
				scope.pageNumber = 1;
				var state = 'video';
				var category;
				scope.config = config;
				scope.selectedCategory={value:'all'};
				scope.videoDetails = {
					videoTitlePosition:{
						value:'top'
					},
					showVideoTitle: false,
					customVideoTitle:''
				}
				scope.disposeVideo = function() {
					if(scope.player) {
						scope.player.dispose();
						scope.player = null;
					}
				}
				scope.setFeaturedVideo = function() {
					scope.currentPostObj.selectedFeaturedVideo = scope.selectedVideoObj;
					$timeout(function(){
						if(scope.currentPostObj.addCategory) {
							scope.currentPostObj.setVideoFunction(scope.currentPostObj.selectedFeaturedVideo,scope.currentPostObj.addCategory)
						} else {
							if(scope.currentPostObj.setFeaturedVideoModal) {
								scope.currentPostObj.setFeaturedVideoFunction(scope.currentPostObj.selectedFeaturedVideo);
							}
							// if(scope.currentPostObj.setFeaturedVideoRussiaModal) {
							// 	scope.currentPostObj.setFeaturedVideoFunction(scope.currentPostObj.selectedFeaturedVideo,'russia')
								
							// } else {
							// 	scope.currentPostObj.setFeaturedVideoFunction(scope.currentPostObj.selectedFeaturedVideo);
							// }
						}
						scope.currentPostObj.cancelVideoModal();
					},0)
				}
				scope.insertVideoToEditor = function() {
					scope.$parent.$parent.$broadcast('insert-telegraftv', { 
						videoId: scope.selectedVideoId,
						showVideoTitle: scope.videoDetails.showVideoTitle,
						title: scope.videoDetails.customVideoTitle,
						align: scope.videoDetails.videoTitlePosition.value
					});
				}
				scope.chooseVideo = function(index,video) {
                  	scope.videoLoaded = false;
                  	scope.selectedVideo = index;
                  	scope.selectedVideoObj = video;
                  	scope.selectedVideoId = video._id;
					if(scope.currentPostObj.insertVideoToEditorModal) {
						scope.videoDetails.customVideoTitle = video.title;
						scope.videoDetails.showVideoTitle = false;
						scope.videoDetails.videoTitlePosition.value='top';
					}
                  	$timeout(function(){
                    	videoplayerFunction(index);
						var posterDisplayRes = (scope.videoItems[index].orientation == 'portrait')? '-360x640.jpg': '-620x350.jpg';
                    	scope.player.poster(scope.config.baseVideoHref + scope.videoItems[index].image.replace('.jpg',posterDisplayRes))
                  	},0)
                  // jQuery('.vjs-poster').css('background-image', 'url('+scope.config.baseVideoHref + scope.videoItems[index].image.replace('.jpg','-620x350.jpg')+')')
              	}
	            scope.searchEmpty = function(value) {
	                if(value.length==0) {
	                  $timeout(function() {
	                    scope.search(value)
	                  },0)
	                }
	            }
	            scope.search =function(value) {
	                if(value.length>0) {
	                  s = value.toLowerCase();
	                } else if(value.length==0){
	                  s = null;
	                }
	                jQuery(".grid").animate({
	                  scrollTop: 0
	                }, 0);
	                scope.pageNumber = 1;
	                getimageLoadFunction();
	            }
	            var videoplayerFunction = function(index) {
	            	scope.player.on("play", function() {
	                  scope.$apply(function() {
	                    scope.durationFlag = false;
	                  })
	                });
	                scope.player.src({
	                  src: scope.videoItems[index].file_video,
	                    type: 'application/x-mpegURL',
	                    withCredentials: false
	                });
	                
	                scope.durationFlag = true;
	                scope.videoLoaded = true;
	            }
	            var getimageLoadFunction = function() {
	              $rootScope.hasLoaded = false;
	                getDataService.get({
	                  param1: state,
	                  param2: null,
	                  limit: 100,
	                  page:scope.pageNumber,
	                  s:s,
	                  status:(scope.scheduled)?'publish,schedule':'publish',
	                  category:category
	                }).$promise.then(function(data){
	                  $rootScope.hasLoaded = true;
	                  scope.emptyTable = false;
	                  scope.videoItems =data.videos;
	                  scope.maxPages = data.max_pages;
	                  for(var i=0; i<scope.videoItems.length;i++) {
						var thumbDisplayRes = (scope.videoItems[i].orientation=='portrait')?'-360x640.jpg' : '-254x191.jpg';
	                    scope.videoItems[i].thumb=scope.config.baseVideoHref + scope.videoItems[i].image.replace('.jpg',thumbDisplayRes); 
	                    scope.videoItems[i].file_video = scope.config.baseVideoHref + scope.videoItems[i].file.m3u8; 
	                    scope.videoItems[i].dateFormated = $filter('date')(scope.videoItems[i].date, "MMM d, y HH:mm")
	                    if(scope.videoItems[i].duration){
	                      var formatedTime;
	                      if(scope.videoItems[i].duration>=3600) {
	                        formatedTime = 'H:mm:ss'
	                      } else{
	                        formatedTime = 'm:ss'
	                      } 
	                      scope.videoItems[i].formated_duration = moment().startOf('day').second(scope.videoItems[i].duration).format(formatedTime);
	                    }
	                  }
	                  scope.selectedVideo = 0;
	                  scope.selectedVideoObj = scope.videoItems[0];
	                  scope.selectedVideoId = scope.videoItems[0]._id;
	                  scope.videoGet = true;
					  if(scope.currentPostObj.insertVideoToEditorModal) {
						scope.videoDetails.customVideoTitle = scope.videoItems[0].title;
						scope.videoDetails.showVideoTitle = false;
						scope.videoDetails.videoTitlePosition.value='top';
					  }
	                  if(!scope.player) {
	                    $timeout(function() {
						var posterDisplayRes = (scope.videoItems[0].orientation == 'portrait')? '-360x640.jpg': '-620x350.jpg';
	                    scope.player = videojs('my-player-directive',
	                    {
							poster:scope.config.baseVideoHref + scope.videoItems[0].image.replace('.jpg',posterDisplayRes),
							// playbackRates: [0.5, 1, 1.5, 2],
							autoplay:false
	                    });
	                      
	                      videoplayerFunction(0);
	                    },0)
	                  } else {
	                    $timeout(function() {
	                      	videoplayerFunction(0);
							var posterDisplayRes = (scope.videoItems[0].orientation == 'portrait')? '-360x640.jpg': '-620x350.jpg';
	                      	scope.player.poster(scope.config.baseVideoHref + scope.videoItems[0].image.replace('.jpg',posterDisplayRes));
	                    },0)
	                  }
	                }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							return
						}
	                  	if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
							function(answer) {
								if(answer==200) {   
								getimageLoadFunction(s);
								}
							},
							function(error) {
							},
							function(progress) {
							// report progress
							});
						} else if(error.status ==502) {
								serverError()
						} else if(error.status ==404) {
							scope.emptyTable = true;
							scope.videoItems = [];
							scope.videoGet = false;
							scope.disposeVideo();
							scope.videoLoaded = false;
						} else {
							alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
						$rootScope.hasLoaded = true; 
	                }); 
	            }
	            getimageLoadFunction();
	            scope.resetAllFilters = function() {
	                jQuery(".grid").animate({
	                  scrollTop: 0
	                }, 0);
	                scope.searchData = null;
	                s =null;
	                category=null;
	                scope.pageNumber = 1;
	                scope.selectedCategory={value:'all'};
	                getimageLoadFunction();
	            }
	            scope.switchCategories = function(item) {
	                if(item=='all') {
	                  category = null;
	                } else {
	                  category = item;
	                }
	                jQuery(".grid").animate({
	                  scrollTop: 0
	                }, 0);
	                scope.pageNumber = 1;
	                getimageLoadFunction();
	            }
	            scope.categoryTreeFunction= function() {
	                scope.categoriesTreeInput = reqursiveService.getReqursiveArray(scope.categories);
	                scope.categoriesTreeSelect = angular.copy(scope.categoriesTreeInput);
	                for(var i=0; i< scope.categoriesTreeSelect.length; i++) {
	                  var n = (scope.categoriesTreeSelect[i].ancestors.length)*2;
	                  var empty = "\u00A0";
	                  for(var j=0;j<n;j++) {
	                    scope.categoriesTreeSelect[i].name = empty+scope.categoriesTreeSelect[i].name;
	                  }
	                }
	            }
	            var getCategoriesFunction = function() {
	                getDataService.get({param1:'video-categories', tree:1}).$promise.then(function(data){      
	                  scope.categories = data.categories;
	                  scope.categoryTreeFunction();
	                  
	                }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							return
						}
	                  	if(error.status == 401) {
	                    var promise = refreshtokenService.getAccessToken();
	                      promise.then(
	                        function(answer) {
	                          if(answer==200) {
	                            getCategoriesFunction();
	                          }
	                        },
	                        function(error) {
	                          // report something
	                        },
	                        function(progress) {
	                         // report progress
	                        });
						} else if(error.status ==502) {
							serverError()
						}
	                });
	            }
	            getCategoriesFunction();
				scope.$on('$destroy',function() {
					scope.disposeVideo();
				})
	        }
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/setFeaturedVideoDirective.js
// module id = 649
// module chunks = 0